import { render, staticRenderFns } from "./Pesagem.vue?vue&type=template&id=f414ab9a"
import script from "./Pesagem.vue?vue&type=script&lang=js"
export * from "./Pesagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports